<template>
  <div class="posters">
    <img
      v-for="(poster, index) in posters"
      :key="index + 1"
      :src="poster"
      alt=""
      draggable="false"
      :class="`poster poster-${index + 1}`"
    />

    <div class="block">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { TimelineMax } from 'gsap'

export default {
  name: 'Posters',
  data () {
    return {
      posters: [
        require('@/assets/images/posters/1.png'),
        require('@/assets/images/posters/2.png'),
        require('@/assets/images/posters/3.png'),
        require('@/assets/images/posters/4.png'),
        require('@/assets/images/posters/5.png'),
        require('@/assets/images/posters/6.png')
      ]
    }
  },
  mounted () {
    const scene = this.$scrollmagic.scene({
      triggerHook: 'onEnter',
      triggerElement: '.chapter-3-panel-1',
      duration: '200%'
    })

    const timeline = new TimelineMax()
      .fromTo('.poster-1', 1, {
        x: 600,
        y: -300
      }, { x: 0, y: 0 }, 0)
      .fromTo('.poster-2', 1, {
        x: -650,
        y: -450
      }, { x: 0, y: 0 }, 0)
      .fromTo('.poster-3', 1, {
        x: 650,
        y: 10
      }, { x: 0, y: 0 }, 0)
      .fromTo('.poster-4', 1, {
        x: -650,
        y: 10
      }, { x: 0, y: 0 }, 0)
      .fromTo('.poster-5', 1, {
        x: 450,
        y: 400
      }, { x: 0, y: 0 }, 0)
      .fromTo('.poster-6', 1, {
        x: -450,
        y: 400
      }, { x: 0, y: 0 }, 0)

    this.$scrollmagic.addScene(
      scene.setTween(timeline)
    )
  }
}
</script>

<style lang="scss" scoped>
.posters {
  margin-top: 2em;
  padding-top: 420px;
  padding-bottom: 150px;
  position: relative;
}

.poster {
  position: absolute;
  width: 130px;

  @media (min-width: 768px) {
    width: 175px;
  }

  &:nth-child(1) {
    right: -30px;
    top: 0;
  }

  &:nth-child(2) {
    left: -30px;
    top: 70px;
  }

  &:nth-child(3) {
    top: 140px;
    right: 70px;
  }

  &:nth-child(4) {
    top: 300px;
    left: -50px;
  }

  &:nth-child(5) {
    top: 350px;
    right: -40px;
  }

  &:nth-child(6) {
    top: 550px;
    left: 0;
  }
}

.block {
  background-color: $c-dark;
  color: white;
  width: 263px;
  margin: 0 auto;
  padding: 28px;
  position: relative;
  z-index: 2;
}
</style>
